import { Component, OnInit } from '@angular/core';

import { OnboardingStateService } from 'src/app/services/onboarding-state.service';
import { AuthService } from 'src/app/services/auth.service';
import { RecommendationsFixedComponent } from '../recommendations-fixed/recommendations-fixed.component';
import { RecommendationsItinerantComponent } from '../recommendations-itinerant/recommendations-itinerant.component';

@Component({
    selector: 'app-recommendations',
    imports: [
    RecommendationsFixedComponent,
    RecommendationsItinerantComponent
],
    template: `
    @if (merchantType === 'fixed') {
      <app-recommendations-fixed
      ></app-recommendations-fixed>
    }
    @if (merchantType === 'itinerant') {
      <app-recommendations-itinerant
      ></app-recommendations-itinerant>
    }
    `
})
export class RecommendationsComponent implements OnInit {
  merchantType: 'fixed' | 'itinerant' = 'fixed';

  constructor(
    private onboardingState: OnboardingStateService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    // Priorité au merchantType de l'onboarding state (sessionStorage)
    const onboardingMerchantType = this.onboardingState.getMerchantType();
    if (onboardingMerchantType) {
      this.merchantType = onboardingMerchantType as 'fixed' | 'itinerant';
    } else {
      // Sinon on lit depuis l'user en sessionStorage
      this.merchantType =
        (this.authService.getCurrentUser()?.merchantType as
          | 'fixed'
          | 'itinerant') || 'fixed';
    }
  }
}
